import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import NavbarClass from "../NavbarClass";
import { Jumbotron } from "react-bootstrap";
import "./Confirmation.css";
import { Helmet } from "react-helmet";
import history from "../../config/history";
import { pageview } from "../../utils/googleAnalyticsUtils";

function Confirmation(props) {

  useEffect(() => {
    pageview('Confirmation');
  }, [])

  const { page, status } = useParams();
  //   const location = useLocation();
  const query = new URLSearchParams(useLocation().search);
  const message = query.get("message");
  const header = query.get("header");
  const statusMap = {
    activation: {
      success: {
        heading: "Welcome to the MeenduToons family!",
        paragraph:
          "Your account has been activated successfully. Your kids can now have fun while learning values",
      },
      fail: {
        heading: "Your account activation failed",
        paragraph: "The activation link has expired, attempt login again",
        "jwt expired": "The activation link has expired, attempt login again",

        // Add more errors here
      },
      progress: {
        heading: "You are just a step away from unlimited Valuetainment!",
        paragraph:
          "We have mailed you an activation link, please check your inbox/spam for the link to activate your account.",
      },
    },
    pricing: {
      success: {
        heading: "Subscription activated successfully!",
        paragraph:
          "Your subscription has been activated successfully, you can now access premium content!",
      },
      progress: {
        heading: "Your Payment is processing",
        paragraph:
          "You will recieve an email about your payment status. If any money has been deducted from your account, please contact us.",
      },
      fail: {
        heading: "Your Payment has failed",
        paragraph: "Please try again or contact us if you need any help",
      },
    },
    cancellation: {
      success: {
        heading: "Your subscription has been cancelled successfully",
        paragraph:
          "We are sorry to see you go. Hope we made a difference with the little time you were with us.",
      },
      fail: {
        heading: "Subscription cancellation failed!",
        paragraph:
          "Some error encountered during cancellation, please contact support",
      },
    },
    pwdReset: {
      success: {
        heading: "Your password has been reset successfully",
        paragraph:
          "Your password reset was successful, please try to login again with the new password",
      },
      progress: {
        heading: "Your Password reset request is intiated",
        paragraph:
          "We have mailed you a password reset link which is valid for 15 minutes, please check your inbox/spam for the link to activate your account",
      },
      fail: {
        heading: "Your password reset was unsuccessful",
        paragraph:
          "Your request either had invalid tokens or the token expired",
      },
    },
  };
  return (
    <div>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      {statusMap[page] && statusMap[page][status] && (
        <div>
          <NavbarClass handleSignInOpen={props.handleSignInOpen} />

          <div
            className="jumbotron"
            style={{
              background:
                status === "success"
                  ? "#64e764"
                  : status === "fail"
                  ? "#FF7F7F"
                  : `#FFEA61`,
            }}
          >
            <div className="container confirmation-container">
              <div
                className={`fa ${
                  status === "success"
                    ? "fa-check"
                    : status === "fail"
                    ? "fa-times"
                    : "fa-clock-o"
                }`}
                style={{ fontSize: "70px" }}
              ></div>
              <div className="confirmation-text-container">
                <h1>
                  {statusMap[page] && statusMap[page][status]
                    ? statusMap[page][status]["heading"]
                    : "Uh Oh."}
                </h1>
                <p class="confirmation-subtext">
                  {message
                    ? message
                    : statusMap[page] && statusMap[page][status]
                    ? statusMap[page][status]["paragraph"]
                    : "Something went wrong"}
                </p>
                {(page === "activation" || page === "pricing") &&
                  status === "success" && (
                    <button className="btn btn-success btn-md mt-2" onClick={() => history.push("/videos")}>
                      Start Watching Videos!
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Confirmation;
